import { progressBarService } from "@/api/client";

export default {
  props: ["campaign"],

  data() {
    return {
      message: {
        error: "Update error.",
        success: "Update success.",
      },
    };
  },
  computed: {
    stamp() {
      return this.campaign.stamp;
    },
    disabled() {
      return this.campaign.status != "draft";
    },
    isNonPanelUser() {
      return this.campaign.user_type !== "contact_id";
    },
  },
  methods: {
    // event: original event
    // type: input type
    // model: input v-model
    async update(event, type, model) {
      try {
        const { id } = this.campaign;

        const name = event.target.name;
        const value = model != undefined ? model : event.target.value;

        const form = {};
        form[name] = value;

        if (type == "color") {
          form[name] = value.replace(/#/gi, "");
        }

        await progressBarService.updateCampaignInfo(id, { stamp: form });

        this.$emit("updated");
        this.$notify(this.message.success);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(this.message.success);
      }
    },

    async uploadImage(event) {
      const file = event.target.files[0];

      try {
        if (!file) return;

        this.validateFileUpload(event);

        const { id } = this.campaign;

        const name = event.target.name;

        const form = new FormData();
        form.append(name, file);

        await progressBarService.fileUpload(id, "stamp", form);

        this.$emit("updated");
        this.$notify(this.message.success);
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(error.message || this.message.error);
      } finally {
        event.target.value = "";
      }
    },

    async removeImage(form) {
      try {
        const { id } = this.campaign;
        const body = { stamp: form };

        await progressBarService.updateCampaignInfo(id, body);
        this.$emit("updated");
        this.$notify("Updated");
      } catch (error) {
        this.$notify("Remove Background image error");
      }
    },

    parseColorValue(color) {
      return color.split("")[0] != "#" ? `#${color}` : color;
    },

    validateFileUpload() {
      return;
    },

    initial() {
      return;
    },
  },

  mounted() {
    this.initial();
  },
};
